/* eslint-disable no-console */
import { Col, Row } from "antd";
import React from "react";
import dayjs from "dayjs";
import { useDispatch, useSelector } from "react-redux";
import { CompletedTripData } from "../Data/TripDetailData";
import CustomRoundedImage from "../../../Core/Components/CustomRoundedImage";
import StopDetails from "../TripDetails/StopDetails";
// import CompletedTripInformation from "../TripDetails/CompletedTripInformation";
import { updateTrips } from "../../../Redux/Slices/trips.slice";
import { useTenantPermission } from "../../../Core/hooks/usePermission";
import { TENANT_PERMISSIONS } from "../../Login/constants";
import UpdateIcon from "../../../Common/Svgs/UpdateIcon";
import SpoiltMilkTooltip from "./SpoiltMilkTooltip";
import TripInformation from "../TripDetails/TripInformation";
import TripRequests from "./TripRequests";

const TripSummaryStops = ({ tripChecklist = [] }) => {
  const dispatch = useDispatch();

  const { tripDetailsKPI, overallSummaryForTrip } = useSelector(
    (state) => state.trips,
  );

  const hasTenantTrikePermission = useTenantPermission([
    TENANT_PERMISSIONS.TRIKE_MODULE_ACCESS,
  ]);

  return (
    <div className="flex flex-col p-6 bg-background h-[calc(100vh-128px)] overflow-y-scroll">
      <Row gutter={8}>
        {CompletedTripData(tripDetailsKPI)
          ?.slice(0, 3)
          ?.map((kpi) => {
            let hours = 0;
            let minutes = 0;

            const startTime = tripDetailsKPI?.startTime;
            const endTime = tripDetailsKPI?.endTime;

            if (startTime && endTime) {
              const differenceInMinutes = dayjs(endTime).diff(
                dayjs(startTime),
                "minutes",
              );

              hours = Math.floor(differenceInMinutes / 60); // Get the hours
              minutes = differenceInMinutes % 60; // Get the remaining minutes
            }

            return (
              <Col span={8} key={kpi.id}>
                <div className="p-4 rounded-md bg-kpi-background">
                  <div className="flex items-center gap-x-2.5">
                    <CustomRoundedImage
                      background="bg-kpi-icon"
                      image={kpi.icon}
                    />
                    <p className="text-xs font-normal capitalize font-aileron text-trip-kpi-title">
                      {kpi.title}
                    </p>
                  </div>

                  {kpi.id === 3 ? (
                    <div className="ml-12 flex items-center gap-x-1">
                      {hours >= 0 && (
                        <p className="text-2xl font-semibold text-trip-kpi-value font-poppins">
                          {hours}
                          <span className="text-base ml-0.5">H</span>
                        </p>
                      )}

                      {minutes >= 0 && (
                        <p className="text-2xl font-semibold text-trip-kpi-value font-poppins">
                          {minutes}
                          <span className="text-base ml-0.5">M</span>
                        </p>
                      )}
                    </div>
                  ) : (
                    <p className="ml-12 text-2xl font-semibold text-trip-kpi-value font-poppins">
                      {kpi.value}

                      {kpi.unit && (
                        <span className="text-base ml-0.5">{kpi.unit}</span>
                      )}
                    </p>
                  )}
                </div>
              </Col>
            );
          })}
      </Row>
      <Row gutter={8} className="mt-2">
        {CompletedTripData(tripDetailsKPI, overallSummaryForTrip)
          ?.slice(6)
          ?.map((kpi) => {
            return (
              <Col span={8} key={kpi.id}>
                <div className="p-4 rounded-md bg-kpi-background">
                  <div className="flex items-center gap-x-2.5">
                    <CustomRoundedImage
                      background="bg-kpi-icon"
                      image={kpi.icon}
                    />
                    <p className="text-xs font-normal capitalize font-aileron text-trip-kpi-title">
                      {kpi.title}
                    </p>
                  </div>

                  <p className="ml-12 text-2xl font-semibold text-trip-kpi-value font-poppins">
                    {kpi.value}

                    {kpi.unit && (
                      <span className="text-base ml-0.5">{kpi.unit}</span>
                    )}
                  </p>
                </div>
              </Col>
            );
          })}
      </Row>

      <Row gutter={8} className="mt-2">
        {CompletedTripData(tripDetailsKPI)
          ?.slice(3, 6)
          ?.map((kpi) => (
            <Col span={8} key={kpi.id}>
              <div className="p-4 rounded-md bg-kpi-background">
                <div className="flex items-center justify-between">
                  <div className="flex items-center gap-x-2.5">
                    <CustomRoundedImage
                      background="bg-kpi-icon"
                      image={kpi.icon}
                    />
                    <p className="text-xs font-normal capitalize font-aileron text-trip-kpi-title">
                      {kpi.title}
                    </p>
                  </div>

                  {kpi.id === 6 && <SpoiltMilkTooltip />}
                </div>

                <div className="ml-12 flex items-center justify-between mr-[22px]">
                  <p className="text-2xl font-semibold text-trip-kpi-value font-poppins">
                    {kpi.value}
                    {kpi.unit && (
                      <span className="text-base ml-0.5">{kpi.unit}</span>
                    )}
                  </p>

                  {kpi.id === 6 && (
                    <div
                      role="button"
                      onClick={() =>
                        dispatch(
                          updateTrips({
                            key: "spoiltMilkModal",
                            value: {
                              visible: true,
                              stops: tripDetailsKPI?.spoiltMilkForStops ?? 0,
                              excess: tripDetailsKPI?.excessSpoiltMilk ?? 0,
                            },
                          }),
                        )
                      }
                    >
                      <UpdateIcon />
                    </div>
                  )}
                </div>
              </div>
            </Col>
          ))}
      </Row>
      <div className="mt-6">
        <TripRequests />
      </div>
      {hasTenantTrikePermission && (
        <Row className="mt-6">
          <Col span={24}>
            <TripInformation tripChecklist={tripChecklist} />
          </Col>
        </Row>
      )}

      {/* <Row className="mt-6">
        <Col span={24}>
          <Commission />
        </Col>
      </Row> */}
      <Row className="mt-6">
        <Col span={24}>
          <StopDetails />
        </Col>
      </Row>
    </div>
  );
};

export default TripSummaryStops;
